import React, { FC, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { PipelineChartProps } from './types';

export const PipelineChart: FC<PipelineChartProps> = ({ graphData }) => {
  const { t } = useTranslate();
  const { primaryChartColor } = useTheme();

  const options: echarts.EChartsOption = useMemo(
    () => ({
      title: {
        text: t('pipeline'),
        subtext: t('byNumberOfVehicles'),
      },
      grid: {
        top: 80,
        left: 50,
        right: 30,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      xAxis: {
        type: 'category',
        data: graphData?.map((o) => o.graphDesc),
        axisLabel: {
          interval: 0,
          fontSize: 8,
        },
      },
      yAxis: { type: 'value' },
      series: [
        {
          type: 'bar',
          data: graphData?.map((o) => o.noOfItems),
          label: { show: true, position: 'top' },
          itemStyle: { color: primaryChartColor },
        },
      ],
    }),
    [graphData, primaryChartColor, t],
  );

  return <ReactECharts option={options} style={{ height: 500 }} />;
};
